import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import type { Quiz } from '@efdigital/ll-addon-data/types/quiz/quiz';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord } from '@warp-drive/utilities/json-api';

/**
 * Finds a quiz by id
 * @param quizId - The id of the quiz to find
 * @returns JSON API request to find the quiz
 */
export function findQuizWithContent(quizId: string) {
  return findRecord<Quiz>(DataTypeQuiz.Quiz, quizId, {
    ...jsonApiOptions,
  } as FindRecordOptions);
}
